import PlayRating from "~/components/PlayRating";
import background from "./background.jpg";
import LazyImage from "~/components/LazyImage";
import ShareButton from "~/components/Share";

type PlayHeaderParams = {
  playId: string;
  coverUrl: string;
  title: string;
  attribution: string;

  userRating: number | null;
  averageRating: number;
  totalRatings: number;
  isAuthenticated: boolean;
};

export default function PlayHeader({
  playId,
  isAuthenticated,
  coverUrl,
  title,
  attribution,
  userRating,
  averageRating,
  totalRatings,
}: PlayHeaderParams) {
  return (
    <div style={{ backgroundImage: `url(${background})` }}>
      <div
        className="flex flex-col lg:flex-row
        w-full 
        lg:max-w-[960px] mx-auto 
        gap-4 lg:gap-36
        items-center
        pt-16 pb-24"
      >
        <div className="h-[390px] w-[260px] rounded overflow-hidden relative bg-black/50 shadow-xs shadow-gray-900/80">
          <LazyImage
            src={coverUrl}
            alt="Play cover image"
            className="w-full h-full object-cover"
            loadingClassName="rounded-md min-[400px]:rounded-none"
          />
        </div>

        <div className="flex flex-col text-white gap-6 mb-6 items-center text-center lg:items-start lg:text-left">
          <div className="px-2 pt-4 pb-2 lg:p-0 text-shadow-sm shadow-gray-900/80">
            <h1 className="text-3xl lg:text-4xl font-medium ">{title}</h1>
            <h2 className="text-lg lg:text-xl font-medium">{attribution}</h2>
          </div>

          <PlayRating
            playId={playId}
            isAuthenticated={isAuthenticated}
            userRating={userRating}
            averageRating={averageRating}
            totalRatings={totalRatings}
          />

          <ShareButton />
        </div>
      </div>
    </div>
  );
}
